import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import GameTagListItem from './tagListItemPos';

const GameTagList = ({ isLoading, tagList, curTagListIdx, checkArr, onChecked, onVideo, onTime, t }) => {
    return tagList.length > 0 ? (
        <Box sx={{ overflowY: 'auto', maxHeight: 'calc(100% - 200px)', minHeight: '30vh' }}>
            <Box sx={{ margin: '0 4px 8px 0', width: 'calc(100% - 4px)' }}>
                {tagList.map((tag, index) => (
                    <GameTagListItem
                        key={index}
                        item={tag}
                        isSelected={curTagListIdx === index}
                        idx={index}
                        isChecked={checkArr[index]}
                        onChecked={onChecked}
                        onShowVideo={onVideo}
                        onChangeTime={onTime}
                    />
                ))}
            </Box>
        </Box>
    ) : (
        <Box sx={{ overflowY: 'auto', maxHeight: 'calc(100% - 300px)', minHeight: 'calc(100% - 250px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isLoading && (
                <div style={{ width: '100%', height: '100%', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </div>
            )}
            {tagList.length === 0 && !isLoading && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '80%' }}>
                    <p className="page-tab-title">{t('No Data to Display')}</p>
                </Box>
            )}
        </Box>
    );
};

export default GameTagList;
